import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/Services/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserData } from 'src/app/Services/data.model';
import { tap } from 'rxjs/operators';
import { ReportNotificationService } from './reportNotification.service';

@Injectable({
  providedIn: 'root'
})
export class AttendanceApiService {

  browserDomain : string = this.service.browserDomain;
  filterData = new BehaviorSubject<any>({})
  constructor(private http: HttpClient, private service: ApiService, private reportNotificationService: ReportNotificationService) { }


  URLAddress(address){
    const FinalURL = this.service.URLAddress(address,'attendance')
    return FinalURL;
  }


  ///////Other Module API......
  scheduledData = new BehaviorSubject<any>({})
  getCourseList(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/course?entity=' +entityId+'&session='+session))
  }
  getCourseData(entityId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/course?id='+entityId) );
  }



  viewAttendanceMaster(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/attendanceMaster?entity=' +entityId+'&session='+session))
  }
  editAttendanceMaster(attendanceMasterData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress("/edit/attendanceMaster"), attendanceMasterData);
  }
  listStudentAttendance(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/list/studentAttendance'), formData)
  }
//d
  listStudentAttendanceNew(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/list/studentAttendanceNew'), formData)
  }
  updateAttendanceValueStudentAttendanceNew(date, subjectCode, sequence,payload): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/updateAttendanceValue/studentAttendanceNew?date='+date+'&subjectCode='+subjectCode+'&sequence='+sequence), payload)
  }
  listMultiStudentAttendance(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/multiCourseList/studentAttendance'),formData)
  }
  listMultiStudentAttendanceNew(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/multiCourseList/studentAttendanceNew'),formData)
  }//d
  getAbsenteeReport(formData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/absenteeReport/studentAttendanceNew'), formData);
  }

  editListStudentAttendance(attendanceData, entityId, session, date, attendanceType, subject, sequence): Observable<UserData>{
    let quaryParams = entityId+'&session='+session+'&date='+date+'&attendanceType='+attendanceType;
    if(sequence){
      quaryParams = quaryParams+'&sequence='+sequence+'&subject='+subject;
    }
    return this.http.post<UserData>(this.URLAddress('/editList/studentAttendance?entity=' +quaryParams), attendanceData)
  }
  editListStudentAttendanceNew(attendanceData, entityId, session, date, attendanceType, subject, sequence,markEmployeeCalendar,employee,admin): Observable<UserData>{
    let quaryParams = entityId+'&session='+session+'&date='+date+'&attendanceType='+attendanceType;
    if(sequence){
      quaryParams = quaryParams+'&sequence='+sequence+'&subject='+subject;
    }
    if(employee)
    {
      quaryParams = quaryParams+'&employee='+employee;
    }
    if(markEmployeeCalendar)
    {
      quaryParams = quaryParams+'&markEmployeeCalendar='+markEmployeeCalendar;
    }
    quaryParams+='&isAdmin='+admin;
    return this.http.post<UserData>(this.URLAddress('/editList/studentAttendanceNew?entity=' +quaryParams), attendanceData)
  }//d
  addMissingStudentAttendance(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/addMissingStudentAttendance/studentAttendance?entity=' +entityId+'&session='+session))
  }
  addMissingStudentAttendanceNew(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/addMissingStudentAttendance/studentAttendanceNew?entity=' +entityId+'&session='+session))
  } //d
  listSchoolCaledar(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/schoolCalendar?entity=' +entityId+'&session='+session))
  }
  addSchoolCalendar(schoolCaledarData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress("/add/schoolCalendar"), schoolCaledarData);
  }
  viewSchoolCalendar(Id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/schoolCalendar?id='+Id))
  }
  editSchoolCalendar(schoolCaledarData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress("/edit/schoolCalendar"), schoolCaledarData);
  }
  deleteSchoolCalendar(id): Observable<UserData> {
    return this.http.delete<UserData>(this.URLAddress('/delete/schoolCalendar?id=' + id));
  }
  assignSchoolCalendar(schoolCaledarData):Observable<any>{
    return this.http.post<any>(this.URLAddress("/assign/schoolCalendar"), schoolCaledarData);
  }

  viewEntityPreferences(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/entityPreferences?entity='+id))
  }
  editEntityPreferences(preferencesData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/entityPreferences'), preferencesData)
  }
  getCoursesByTeacher(entityId, session, attendanceType,teacher,isAdmin): Observable<UserData[]>{
    let queryParams = entityId+ '&session='+session+'&teacher='+teacher+ '&attendanceType='+attendanceType
    if(isAdmin){
      queryParams = queryParams + '&isAdmin='+isAdmin
    }
    return this.http.get<UserData[]>(this.URLAddress('/getCoursesByTeacher/subjectCourseMapping?entity='+queryParams))
  }
  getEmployeeCalendar(entityId, session,teacher,date): Observable<UserData[]>{
    let queryParams = entityId+ '&session='+session+'&teacher='+teacher+ '&date='+date
    return this.http.get<UserData[]>(this.URLAddress('/getEmployeeCalendar/timeTable?entity='+queryParams))
  }
  getEmployeeCalendarNew(entityId, session,teacher,date): Observable<UserData[]>{
    let queryParams = entityId+ '&session='+session+'&teacher='+teacher+ '&date='+date
    return this.http.get<UserData[]>(this.URLAddress('/getEmployeeCalendar/employeeCalendar?entity='+queryParams))
  }
  viewAttendanceSummary(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/attendanceSummary/studentAttendance'), preferencesData)
  }
  viewAttendanceSummaryNew(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/attendanceSummary/studentAttendanceNew'), preferencesData)
  }//d
  viewInstituteSummary(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/instituteSummary/studentAttendance'), preferencesData)
  }
  viewInstituteSummaryNew(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/instituteSummary/studentAttendanceNew'), preferencesData)
  }//d

  facultyLoadReport(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/facultyLoadReport/employeeCalendar'), formData);
  }
  employeeLectureRangeReport(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/employeeLectureRangeReport/employeeCalendar'), formData);
  }
  getDepartmentEmployeeList(entityId: string, department: string): Observable<any> {
    return this.http.get<any>(this.URLAddress('/list/Employee?entity=' + entityId + '&department=' + encodeURIComponent(department)));
  }
  getEmployeeById(id: string): Observable<any> {
    return this.http.get<any>(this.URLAddress('/view/employee?id=' + id));
  }
  viewAttendanceReport(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/attendanceReport/studentAttendance'), preferencesData)
  }
  viewAttendanceReportNew(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/attendanceReport/studentAttendanceNew'), preferencesData)
  }//d
  viewDailyAttendanceReportDepartmentWise(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/dailyAttendanceReportDepartmentWise/employeeAttendance'), preferencesData)
  }
  viewEmployeeWiseDailyAttendanceReport(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/employeeWiseAttendanceReport/studentAttendance'), formData)
  }
  viewEmployeeWiseDailyAttendanceReportNew(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/employeeWiseAttendanceReport/studentAttendanceNew'), formData)
  }//d
  sendMarkAttendanceReminder(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/sendMarkAttendanceReminder/studentAttendance'), formData)
  }
  sendMarkAttendanceReminderNew(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/sendMarkAttendanceReminder/studentAttendanceNew'), formData)
  }//d

  searchEmployee(name, entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/search/employee?search='+name +'&entity=' +entityId+'&session='+session) );
  }
  viewNotMarkedSummary(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/notMarkedReport/studentAttendance'), preferencesData)
  }
  viewNotMarkedSummaryNew(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/notMarkedReport/studentAttendanceNew'), preferencesData)
  }//d
  viewCourseWiseSummary(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/allSubjectsAttendanceSummary/studentAttendance'), preferencesData)
  }
  viewCourseWiseSummaryNew(preferencesData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/allSubjectsAttendanceSummary/studentAttendanceNew'), preferencesData)
  }//d
  studentWiseSubjectAttendanceReportNew(payload): Observable<any[]> {
    return this.http.post<any[]>(this.URLAddress('/allSubjectsAttendanceSummary/studentAttendanceNew'), payload);
  }
  viewDailyEmployees(entity,session,date):Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/dailySchedule/timeTable?entity='+entity+'&session='+session+'&date='+date))
  }
  viewDailyEmployeesNew(entity,session,date):Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/dailySchedule/employeeCalendar?entity='+entity+'&session='+session+'&date='+date))
  }
  viewSingleEmployee(entity,session,employee,startDate,endDate):Observable<UserData>{
    let quaryParams = entity+'&session='+session+'&startDate='+startDate+'&endDate='+endDate
    if(employee)
    {
      quaryParams = quaryParams+'&employee='+employee;
    }
    return this.http.get<UserData>(this.URLAddress('/employeeSchedule/timeTable?entity='+quaryParams))
  }
  viewSingleEmployeeNew(entity,session,employee,startDate,endDate):Observable<UserData>{
    let quaryParams = entity+'&session='+session+'&startDate='+startDate+'&endDate='+endDate
    if(employee)
    {
      quaryParams = quaryParams+'&employee='+employee;
    }
    return this.http.get<UserData>(this.URLAddress('/employeeSchedule/employeeCalendar?entity='+quaryParams))
  }
  checkEmployeeAvailability(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/checkEmployeeAvailability/timeTable'), formData)
  }
  substituteEmployee(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/substitute/timeTable'), formData)
  }
  substituteEmployeeNew(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/substitute/employeeCalendar'), formData)
  }
  attendanceMarked(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/attendanceMarked/timeTable'), formData)
  }
  attendanceMarkedNew(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/attendanceMarked/employeeCalendar'), formData)
  }
  getSubjectsByCourse(entityId, session, course, stream, batch, section):Observable<UserData>{
    let queryParams = 'entity='+ entityId+'&session='+session;

    if(course){
      queryParams = queryParams + '&course='+encodeURIComponent(course);
    }
    if(stream){
      queryParams = queryParams + '&stream='+stream;
    }
    if(batch){
      queryParams = queryParams + '&batch='+batch;
    }
    if(section){
      queryParams = queryParams + '&section='+section;
    }
    return this.http.get<UserData>(this.URLAddress('/getSubjectsByCourse/subjectCourseMapping?'+queryParams))
  }
  statusReport(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/statusReport/timeTable'), formData)
  }
  statusReportNew(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/statusReport/employeeCalendar'), formData)
  }

  deleteListStudentAttendance(attendanceData, entityId, session, date, attendanceType, subject, sequence): Observable<UserData>{
    let quaryParams = entityId+'&session='+session+'&date='+date+'&attendanceType='+attendanceType;
    if(sequence){
      quaryParams = quaryParams+'&sequence='+sequence+'&subject='+subject;
    }
    return this.http.post<UserData>(this.URLAddress('/deleteList/studentAttendance?entity=' +quaryParams), attendanceData)
  }
  deleteListStudentAttendanceNew(attendanceData, entityId, session, date, attendanceType, subject, sequence): Observable<UserData>{
    let quaryParams = entityId+'&session='+session+'&date='+date+'&attendanceType='+attendanceType;
    if(sequence){
      quaryParams = quaryParams+'&sequence='+sequence+'&subject='+subject;
    }
    return this.http.post<UserData>(this.URLAddress('/deleteList/studentAttendanceNew?entity=' +quaryParams), attendanceData)
  }//d
  listSubject(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/subject?entity='+entityId+ '&session='+ session))
  }

  listAssessmentConfig(entityId, session, course, stream, batch, section): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/assessmentConfig?entity='+entityId+ '&session='+ session+'&course='+encodeURIComponent(course)+'&stream='+stream+'&batch='+batch+'&section='+section))
  }
  listAttendanceMarksSetup(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/attendanceMarksSetup?entity='+entityId+ '&session='+ session))
  }
  viewAssessmentGradeSetup(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/assessmentGradeSetup?id='+id))
  }
  editAssessmentMarks(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/assessmentMarks'), formData)
  }

  listAppliedLeave(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/list/appliedLeave'),formData)
  }
  viewAppliedLeave(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/appliedLeave?id='+id))
  }
  editLeave(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/appliedLeave'), formData)
  }
  viewCourseScheduleTimeTable(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/courseSchedule/timeTable'),formData)
  }
  viewCourseScheduleTimeTableNew(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/courseSchedule/employeeCalendar'),formData)
  }
  cancelLecture(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/cancelLecture/timetable'),formData)
  }
  cancelLectureNew(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/cancelLecture/employeeCalendar'),formData)
  }
  editEmployeeCalendar(formData: any, ): Observable<any> {
    let url = '/edit/employeeCalendar';
    // if (queryParam) {
    //   url += queryParam.startsWith('?') ? queryParam : '?' + queryParam;
    // }
    return this.http.post<any>(this.URLAddress(url), formData);
  }
  updateLecture(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/updateLectureStatus/timeTable'),formData)
  }
  updateLectureNew(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/updateLectureStatus/employeeCalendar'),formData)
  }

  getSubjectWiseAttendance(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/subjectWiseAttendance/studentAttendance?studentAttendance='+id))
  }
  getSubjectWiseAttendanceNew(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/subjectWiseAttendance/studentAttendanceNew?studentAttendance='+id))
  }
  deleteAppliedLeave(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/appliedLeave?id='+id))
  }
  addLessonCrud(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/add/lessonPlan'),formData)
  }

  editLessonCrud(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/edit/lessonPlan'),formData)
  }
  viewLessonCrud(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/lessonPlan?id='+id))
  }
  listLessonCrud(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/list/lessonPlan'),formData)
  }
  deleteLessonPlan(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/delete/lessonPlan?id='+id))
  }
  saveLessons(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/saveLessonCovered/timeTable'),formData)
  }
  saveLessonsNew(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/saveLessonCovered/employeeCalendar'),formData)
  }
  attendanceNotMarkedReport(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/attendanceNotMarkedReport/timeTable'),formData)
  }
  viewHrmMaster(entityId): Observable<any> {
    return this.http.get<any>(this.URLAddress('/view/hrmMaster?entity=' + entityId))
  }
  saveAttendaceOfAllStudents(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/markAll/studentAttendance'),formData)
  }

  attendanceNotMarkedReportNew(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/attendanceNotMarkedReport/employeeCalendar'),formData)
  }
  listStudentAttendanceV3(formData)
  {
    return this.http.post<UserData>(this.URLAddress('/getList/studentAttendanceV3'), formData);
  }
  editStudentAttendanceV3(formData):Observable<any>
  {
    return this.http.post<UserData>(this.URLAddress('/saveList/studentAttendanceV3'), formData);
  }
  facultyWiseNotMarkedReport(formData):Observable<any>
  {
    return this.http.post<UserData>(this.URLAddress('/employeeWiseNotMarkedReport/studentAttendanceV3'), formData);
  }
  searchStudentWithCourse(name, entityId, session,course,stream,batch,section): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/search/student?search='+name +'&entity=' +entityId+'&session='+session+'&course='+course+'&stream='+stream+'&batch='+batch+'&section='+section) );
  }
  listStudentWiseNotMarkedReportData(formData)
  {
    return this.http.post<UserData>(this.URLAddress('/studentWiseNotMarkedReport/studentAttendanceV3'), formData);
  }
  // addAttendanceReportFile(formData)
  // {
  //   return this.http.post<UserData>(this.URLAddress('/addAttendanceReport/reportFile'), formData);
  // }
  editMultipleStudentAssessmentMarks(formData)
  {
    return this.http.post<UserData>(this.URLAddress('/editMultipleSubjects/assessmentMarks'), formData);
  }
  viewPdfDefaultTemplate(entity, name): Observable<any> {
      return this.http.get<any>(this.URLAddress('/viewDefault/pdfTemplate?entity=' + entity + '&report=' + name));
    }
     viewDefaultTemplate(entity,name,course):Observable<any>{
    return this.http.get<any>(this.URLAddress('/viewDefault/pdfTemplate?entity='+entity+'&report='+name+'&course='+encodeURIComponent(course)));
  }
  viewPDFDefaultTempaltes(entityType,reportName): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/viewDefault/defaultPDFTemplate?report='+reportName+'&entityType='+entityType));
  }


  addAttendanceReportFile(formData)
  {
    return this.http.post<UserData>(this.URLAddress('/addAttendanceReport/reportFile'), formData).pipe(
      tap(() => this.reportNotificationService.notifyReportGenerated())
    );
  }
 
 
    getSessionList(entityId): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/session?entity=' +entityId))
    }
  getEdrReport(formData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/edrReport/studentAttendanceNew'),formData)
  }

  sendCourseWiseAttendanceSummaryEmail(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendCourseWiseAttendanceSummaryEmail/communication'), formData)
  }
  sendCourseWiseAttendanceSummaryWhatsApp(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendCourseWiseAttendanceSummaryWhatsApp/communication'), formData)
  }
  listStudentBiometricFetchRecord(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/list/studentBiometricFetchRecord'), formData)
  }
  getAttendanceDashboard(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/getAttendanceDashboard/studentBiometricFetchRecord'), formData);
  }
  getCourseAttendanceReport(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/courseAttendanceReport/studentBiometricFetchRecord'), formData);
  }
  getStudentBiometricReport(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/studentBiometricReport/studentBiometricFetchRecord'), formData);
  }

  getDepartmentTeacherLectureReport(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/departmentTeacherLectureReport/employeeCalendar'), formData);
  }
  addBackDateAttendanceMarking(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/add/backDateAttendanceMarking'), payload);
  }
  listBackDateAttendanceMarking(entityId, session): Observable<any> {
    return this.http.get<any>(this.URLAddress('/list/backDateAttendanceMarking?entity=' + entityId + '&session=' + session));
  }
  viewBackDateAttendanceMarking(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/view/backDateAttendanceMarking?id=' + id));
  }
  editBackDateAttendanceMarking(id, payload): Observable<any> {
    let queryParam = id ? '?id=' + id : '';
    return this.http.post<any>(this.URLAddress('/edit/backDateAttendanceMarking' + queryParam), payload);
  }
  deleteBackDateAttendanceMarking(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/delete/backDateAttendanceMarking?id=' + id));
  }

  facultyAvailabilityReport(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/facultyAvailabilityReport/employeeCalendar'), formData);
  }

  listLectureScheduleMaster(formData): Observable<UserData[]> {
    return this.http.post<UserData[]>(this.URLAddress('/list/lectureScheduleMaster'), formData);
  }
}

